export default __webpack_public_path__ + "static/media/homeBanner.23fd3280.jpg";